import { createFileRoute } from '@tanstack/react-router'
import { createOrgShortcutComponent } from '~/pages/org-shortcuts'

export const Route = createFileRoute('/go/org/people')({
  component: createOrgShortcutComponent('/org/$org/people')
})
